import { OmapiIdConstants } from '../../omapi-id-constants';
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    DateUtil.getNameOfDay = function (date, locale) {
        return date.toLocaleDateString(locale, { weekday: 'long' });
    };
    DateUtil.getlocaleDate = function (date, locale) {
        return date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
    };
    DateUtil.getTrialEndDate = function (trial) {
        var endDate = new Date();
        var duration = Number(trial.duration);
        if (trial.omapiId === OmapiIdConstants.PLAY_SPORTS_TRIAL
            || trial.omapiId === OmapiIdConstants.DAY_PASS) {
            endDate.setDate(endDate.getDate() + 1);
        }
        else if (trial.duration) {
            endDate.setDate(endDate.getDate() + duration);
        }
        return endDate;
    };
    return DateUtil;
}());
export { DateUtil };
